import { render, staticRenderFns } from "./IdeasDetail.vue?vue&type=template&id=3a5cf34d"
import script from "./IdeasDetail.vue?vue&type=script&lang=js"
export * from "./IdeasDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports